import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { GET_ALL_BANNERS } from "./actionTypes";
import { getAllBannersCall } from "../../helpers/repository";
import { getAllBannersResponseSuccess } from "./actions";
import { showErrorMessages } from "../../components/Common/Utils/helpers";

function* attemptGetAllBanners() {
  try {
    const response = yield call(getAllBannersCall);
    yield put(getAllBannersResponseSuccess(response.data.data));
  } catch (error) {
    showErrorMessages(error);
  }
}

function* BannersSaga() {
  yield takeEvery(GET_ALL_BANNERS, attemptGetAllBanners);
}

export default BannersSaga;
